import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { Dashboard } from './pages/Dashboard';
import { DischargeSummaries } from './pages/DischargeSummaries';
import { BillingItems } from './pages/BillingItems';
import { InsuranceCases } from './pages/InsuranceCases';
import { KnowledgeBase } from './pages/KnowledgeBase';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="flex min-h-screen bg-background w-full" data-id="element-1">
        <Sidebar data-id="element-2" />
        <main className="flex-1 ml-[240px]" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Dashboard data-id="element-6" />} data-id="element-5" />
            <Route path="/discharge-summaries" element={<DischargeSummaries data-id="element-8" />} data-id="element-7" />
            <Route path="/billing-items" element={<BillingItems data-id="element-10" />} data-id="element-9" />
            <Route path="/insurance-cases" element={<InsuranceCases data-id="element-12" />} data-id="element-11" />
            <Route path="/knowledge-base/*" element={<KnowledgeBase data-id="element-14" />} data-id="element-13" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-16" />} data-id="element-15" />
          </Routes>
        </main>
      </div>
    </BrowserRouter>;
}